
import React from 'react';
import { PawPrint } from 'lucide-react';
import { generateUrgencyMessage } from './HeroUtils';

interface HeroUrgencyMessageProps {
  message?: string;
}

const HeroUrgencyMessage: React.FC<HeroUrgencyMessageProps> = ({ message }) => {
  const displayMessage = message || generateUrgencyMessage();
  
  return (
    <div className="bg-[#5E6C2F] text-[#f7f0de] py-2 px-5 rounded-full inline-flex items-center gap-2 mb-8 shadow-md">
      <PawPrint className="w-4 h-4" aria-hidden="true" />
      <p className="text-base md:text-lg font-montserrat font-medium">
        {displayMessage}
      </p>
    </div>
  );
};

export default HeroUrgencyMessage;
